import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Navigation } from "../../../components/v2/Navigation/Navigation";
import { Notifications } from "../../../components/Notification";
import { useMediaQuery } from "@mui/system";
import { useBlobColor } from "../../../utils/useBlobColor/useBlobColor";
import { LayoutContext } from "../LayoutProvider";
import { checkIsShowSmallMenu } from "../../../components/FormNavigation/utils";
import { ApplicationStatus } from "../../../components/ApplicationStatus/ApplicationStatus";
import { ERROR_MESSAGES } from "../../../constants";
import { HeaderTitle } from "../../../components/HeaderTitle";
import HeaderProgressBar from "../../../components/ProgressBar/ProgressBarContainer";
import { useCompletionPercentage } from "../../../hooks/useCompletionPercentage";

import { FormLayoutContainer, FormWrapper, FormInner, MainContainer } from "./styled";

export const FormLayoutComponent = ({
  screeningError,
  errorCode,
  errorIcon,
  pathname,
  children
}) => {
  const [
    isDisplayHeader = false,
    isDisplayScreeningError = false,
    hasVerticalPagination = false
  ] = useContext(LayoutContext);
  const blobColor = useBlobColor();
  const isSmallContentWidth = !checkIsShowSmallMenu(pathname);
  const isMobile = useMediaQuery("(max-width: 768px)") || window.innerWidth <= 768;

  // Use the completion percentage hook to maintain the calculation logic
  // even when FormNavigation UI is hidden
  useCompletionPercentage();

  let content;
  if (screeningError.error && isDisplayScreeningError) {
    content = <ApplicationStatus {...screeningError} />;
  } else if (errorCode) {
    content = <ApplicationStatus icon={errorIcon} text={ERROR_MESSAGES[errorCode]} />;
  } else {
    content = children;
  }

  return (
    <FormLayoutContainer color={blobColor}>
      {/* <FormNavigation /> */}
      <FormWrapper isSmallContentWidth={isSmallContentWidth}>
        <FormInner>
          <MainContainer
            hasVerticalPagination={hasVerticalPagination}
            isSmallContentWidth={isSmallContentWidth}
          >
            {isDisplayHeader && <HeaderTitle />}
            <Notifications />
            {isMobile && <HeaderProgressBar />}
            {content}
          </MainContainer>
        </FormInner>
      </FormWrapper>
      <Navigation />
    </FormLayoutContainer>
  );
};

FormLayoutComponent.propTypes = {
  screeningError: PropTypes.shape({
    error: PropTypes.bool,
    message: PropTypes.string
  }),
  errorCode: PropTypes.string,
  errorIcon: PropTypes.node,
  pathname: PropTypes.string,
  children: PropTypes.node
};
